import { jsx as r, jsxs as p } from "react/jsx-runtime";
import { classes as b } from "../../utils/styles.js";
import { IconChevronRight as g } from "../Icon/icons/IconChevronRight.js";
import e from "./breadcrumb.module.js";
const v = ({
  breadcrumbDestinationMap: a,
  chevronColor: c,
  ariaLabel: l,
  containerClassName: m,
  onNavigate: t,
  unsetPadding: d,
  ...h
}) => {
  const i = Array.from(a.entries()), f = i.length - 1;
  return /* @__PURE__ */ r(
    "nav",
    {
      className: b([
        m ?? "",
        e.breadcrumbContainer,
        d ? e.unsetPadding : ""
      ]),
      "aria-label": l,
      ...h,
      children: /* @__PURE__ */ r("ol", { className: e.breadcrumb, children: i.map(([n, o], s) => /* @__PURE__ */ p("li", { children: [
        /* @__PURE__ */ r(
          "a",
          {
            href: n,
            title: o,
            onClick: (u) => {
              t && (u.preventDefault(), t(n));
            },
            children: o
          }
        ),
        s < f && /* @__PURE__ */ r(
          g,
          {
            color: c,
            "aria-hidden": "true",
            width: 18,
            height: 18
          }
        )
      ] }, s)) })
    }
  );
};
export {
  v as Breadcrumb
};
